import { organizationsApi } from '../services/api';

export function createTopLevelOrganization({ name, organizationType }) {
    return organizationsApi.create({
        name,
        organization_type: organizationType,
    });
}
